module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/guide1-9a3db58777131d9e64cdeddd73c6e550.png";